export enum DeliveryType {
  MainRelease,
  CompactRelease,
  ServiceReleaseAndHotfix,
  ServiceRelease,
  Hotfix
}
